<template>
    <div class="box">
        <div class="box-header pb-0">
            <div class="d-flex">
                <div class="pl-3 pr-3">
                    <router-link :to="{ name: 'Account' , params: { id: company_id }}">
                        <el-button size="medium"
                                   class="pl-3 pr-2">
                            <i class="fa fa-chevron-left mr-2"></i>
                        </el-button>
                    </router-link>
                </div>
                <h1 v-if="rate">{{ rate.name }}</h1>
            </div>
        </div>
        <div class="col-md-3">
            <p class="mb-1"
                v-if="rate">
                Rate: {{ rate.name }}
            </p>
            <p class="mb-1"
                v-if="rate">
                Use Case: {{ rate.use_case ?? '-' }}
            </p>
            <p class="b-a p-2 mb-0"
                v-if="rate">
                <span>Local PN: ${{ rate.local_pn }}</span>
                <br>
                <span>Toll-free Phone Numbers: ${{ rate.tollfree_pn }}</span>
                <br>
                <span>Local Min: ${{ rate.local_min }}</span>
                <br>
                <span>Toll-free Min: ${{ rate.tollfree_min }}</span>
                <br>
                <span>Branded Calls: ${{ rate.branded_call }}</span>
                <br>
                <span>Enhanced Branded Calls: ${{ rate.enhanced_branded_call }}</span>
                <br>
                <span>Local SMS: ${{ rate.local_sms }}</span>
                <br>
                <span>Toll-free SMS: ${{ rate.tollfree_sms }}</span>
                <br>
                <span>Short Code SMS: ${{ rate.short_code_sms }}</span>
                <br>
                <span>Local MMS: ${{ rate.local_mms }}</span>
                <br>
                <span>Toll-free MMS: ${{ rate.tollfree_mms }}</span>
                <br>
                <span>Short Code MMS: ${{ rate.short_code_mms }}</span>
                <br>
                <span>RVM: ${{ rate.rvm }}</span>
                <br>
                <span>LRN Lookup: ${{ rate.lrn_lookup }}</span>
                <br>
                <span>Spam Lookup: ${{ rate.spam_lookup }}</span>
                <br>
                <span>AMD: ${{ rate.amd }}</span>
                <br>
                <span>Email: ${{ rate.email }}</span>
                <br>
                <span>Fax: ${{ rate.fax }}</span>
                <br>
                <span>International Call Factor: {{ formatInternationalFactor(rate.intl_call_factor) }}</span>
                <br>
                <span>International SMS Factor: {{ formatInternationalFactor(rate.intl_sms_factor) }}</span>
                <br>
                <span>Transcription: ${{ rate.transcription }}</span>
                <br>
                <span>AloAi Agent Text Enrollment: ${{ rate.aloai_text_bot_enrollment }}</span>
                <br>
                <span>AloAi Voice Bot Enrollment: ${{ rate.aloai_voice_bot_enrollment }}</span>
                <br>
                <span>AloAi Voice Agent Basic Minute: ${{ rate.aloai_voice_bot_basic_minute }}</span>
                <br>
                <span>AloAi Voice Agent Premium Minute: ${{ rate.aloai_voice_bot_premium_minute }}</span>
                <br>
                <span>AloAi Voice Agent Ultra Premium Minute: ${{ rate.aloai_voice_bot_ultra_premium_minute }}</span>
                <br>
                <span>RCS: ${{ rate.rcs }}</span>
                <br>
                <span>RCS Media: ${{ rate.rcs_media }}</span>
            </p>
        </div>
    </div>
</template>

<script>
import auth from '../auth'

export default {
    data() {
        return {
            auth: auth,
            rate: null,
            company_id: null,
        }
    },

    mounted() {
        this.company_id = this.$route.params.company_id
        this.fetchRate(this.$route.params.id)
    },

    methods: {
        fetchRate(rate_id) {
            axios.get(`/api/admin/rate/${rate_id}`)
                .then(res => {
                    this.rate = res.data
                })
                .catch(err => {
                    this.$notify.error({
                        title: 'Error loading rates',
                        message: err.response.data.message,
                    });
                })
        },

        formatInternationalFactor(factor) {
            const multiplier = parseFloat(factor).toFixed(3)
            const percentage = (parseFloat(factor) * 100).toFixed(0)
            return `${multiplier} (${percentage}%)`
        },
    }
}
</script>
